import rehypeKatex from "rehype-katex";

/**
 * A safe wrapper around rehypeKatex that catches errors and silently continues processing.
 *
 * Issue: The upstream rehype-katex@7.0.1 plugin crashes with "Cannot read properties of undefined
 * (reading 'className')" when processing certain HTML structures like footnote references ([^4])
 * that generate <sup> elements within <a> tags.
 * The plugin attempts to access the className property on undefined objects during its DOM
 * traversal.
 *
 * This wrapper catches those errors and allows markdown processing to continue without crashing
 * the component.
 */

export const safeRehypeKatex = (options = {}) => {
  return (tree, file) => {
    try {
      const katexProcessor = rehypeKatex(options);
      // Note: Type incompatibility exists between react-markdown@8.0.7 (uses vfile@5.3.7) and
      // rehype-katex@7.0.1 (uses vfile@6.0.3). Consider upgrading to react-markdown@10+ for proper
      // type compatibility.
      return katexProcessor(tree, file);
    } catch (error) {
      // Log the error for debugging but don't throw.
      console.warn("rehypeKatex processing error:", error);
      // Return the tree unchanged
      return tree;
    }
  };
};
//# sourceMappingURL=safeRehypeKatex.js.map